// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { tags16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-tags': IconTags;
    }
}

/**
 * The icon component for the 'tags' icon
 */
export class IconTags extends Icon {
    public constructor() {
        super(tags16X16);
    }
}

registerIcon('icon-tags', IconTags);
export const iconTagsTag = 'nimble-icon-tags';
